export default "__VITE_ASSET__1AW0gXAe__"